import React from "react";
import { observer } from "mobx-react";
import numeral from "numeral";
import { Button, Spinner } from "../../../-common";
import "./CheckoutButton.scss";

const CheckoutButton = ({ style, action, total, disabled, processing, hasProductsToShip, canRetry, errorType }) => {
  let actionButtonContent = `COMPLETE PURCHASE (${numeral(total / 100).format("$0,00.00")})`;
  if (!hasProductsToShip) actionButtonContent = "COMPLETE ENROLLMENT";

  // Show retry button for retryable errors
  if (canRetry && !processing) {
    actionButtonContent = "RETRY ENROLLMENT";
  }

  // Show processing spinner
  if (processing) actionButtonContent = <Spinner />;

  // Determine button style based on error type
  let buttonClass = "checkout-button";
  if (canRetry && errorType === 'PAYMENT_ERROR') {
    buttonClass += " retry-payment";
  }

  return (
    <Button type="cta" className={buttonClass} style={style} action={action} disabled={disabled}>
      {actionButtonContent}
    </Button>
  );
};

export default observer(CheckoutButton);
